<template>
  <div id="app">
    <!-- <div v-if="$store.state.loading" class="loading">
      <img
        class="loading__rotator"
        src="@/assets/img/preloader.png"
        alt="loader"
      />
    </div> -->

    <component :is="layout">
      <router-view></router-view>
    </component>
  </div>
</template>
<script>
import EmptyLayout from '@/components/layouts/EmptyLayout';
import MainLayout from '@/components/layouts/MainLayout';
import { callNotifications } from '@/utils/mixins';
export default {
  mixins: [callNotifications],
  computed: {
    layout() {
      return (this.$route.meta.layout || 'empty') + '-layout';
    }
  },
  methods: {},
  components: {
    EmptyLayout,
    MainLayout
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/common';
</style>
